import { Button, Popconfirm, Select, Space, Table } from 'antd';
import _ from 'lodash'
import { useCategoryData, useTicketGroups } from 'pages/store';
import React, { useEffect, useState } from 'react'
import AddNewSubcat from './AddNewSubcat';
import { QuestionCircleOutlined } from '@ant-design/icons';

const SubcategoryGroupMapping = ({ assigneeGroups }) => {
    const { fetchGroupAssignedToSubcategory, groupAssignedToSubcategories, deleteSubcategoryGroup } = useTicketGroups();
    const { fetchCategoryData, categorySubcatData } = useCategoryData()
    useEffect(() => {
        fetchCategoryData();
        fetchGroupAssignedToSubcategory();
    }, [])
    const [groupNameOption, setGroupNameOption] = useState([])
    useEffect(() => {
        const groupIds = assigneeGroups.map(([groupName, _]) => {
            return { label: groupName, value: groupName };
        })
        setGroupNameOption(groupIds);
    }, [assigneeGroups])

    const [subcategoryMap, setSubcategoryMap] = useState([]);
    const [subcatAndGroups, setSubcatAndGroups] = useState([]);
    useEffect(() => {
        const subcategories = _.get(categorySubcatData, ['data', 'subcategory'], []);
        const subcategoryKeys = [];
        for (const subcategory of Object.values(subcategories)) {
            const alreadyAssignedSubcats = groupAssignedToSubcategories.map(subcat => subcat.sub_category);
            const keys = subcategory.map((subcat) => { return { value: subcat.key, label: subcat.label } })
                .filter(subcat => !alreadyAssignedSubcats.includes(subcat.value))
            subcategoryKeys.push(...keys);
        }
        setSubcategoryMap(subcategoryKeys);
        setSubcatAndGroups(groupAssignedToSubcategories);
    }, [groupAssignedToSubcategories, categorySubcatData]);

    const removeSubcat = (subcatAndGroup) => {
        deleteSubcategoryGroup(subcatAndGroup);
    }

    const columns = [
        {
            title: 'Subcategory',
            dataIndex: 'sub_category',
            key: 'sub_category',
        },
        {
            title: 'Group Name',
            dataIndex: 'group_id',
            key: 'group_id',
        },
        {
            title: 'Assign New Group',
            dataIndex: 'assign_new_group',
            key: 'assign_new_group'
        },
        {
            title: 'Remove Subcategory',
            dataIndex: 'remove',
            key: 'remove',
        }
    ];

    const dataSource = subcatAndGroups.map((subcatAndGroup) => {
        return {
            key: subcatAndGroup.user_id,
            sub_category: subcatAndGroup.sub_cat_display_name,
            group_id: subcatAndGroup.group_id,
            assign_new_group: <SelectTheGroupId subCategory={subcatAndGroup} groupNameOption={groupNameOption} existingGroupId={subcatAndGroup.group_id} />,
            remove: <Popconfirm
                title={`Remove the ${subcatAndGroup.sub_cat_display_name}`}
                description={`Are you sure to remove ${subcatAndGroup.sub_cat_display_name} subcategory from round robin?`}
                okText="Yes"
                onConfirm={() => removeSubcat(subcatAndGroup)}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                cancelText="No"
            >
                <Button danger>Remove</Button>
            </Popconfirm>
        }
    })
    return (
        <div>
            <AddNewSubcat subcategoryMap={subcategoryMap} groupNameOption={groupNameOption} />
            {!(_.isEmpty(subcatAndGroups)) && <Table
                columns={columns}
                dataSource={dataSource}
            />}
        </div>
    )
}

export default SubcategoryGroupMapping

const SelectTheGroupId = ({ subCategory, groupNameOption, existingGroupId }) => {
    const { addGroupToSubcategory } = useTicketGroups();
    const [selectedGroupId, setSelectedGroupId] = useState()

    const onChange = (value) => {
        setSelectedGroupId(value);
    };

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return <>
        <Space.Compact style={{ width: '50%', display: 'flex' }}>
            <Select
                className='flex-1'
                showSearch
                placeholder="Select a group"
                optionFilterProp="children"
                onChange={onChange}
                filterOption={filterOption}
                options={groupNameOption.filter(option => option.value !== existingGroupId)}
            />
            <Button type="primary"
            disabled={!selectedGroupId}
            onClick={() => {
                addGroupToSubcategory({
                    groupData: [{
                        sub_category: subCategory.sub_category,
                        sub_cat_display_name: subCategory.sub_cat_display_name,
                        group_id: selectedGroupId
                    }], action: 'Assigned'
                });
            }}>Submit</Button>
        </Space.Compact>
    </>
}